<template lang="html">
  <div class="table-responsive">
    <table class="table table-bordered table-condensed table-hover">
      <thead>
      <tr>
        <th class="center">#</th>
        <th class="center">Jugador</th>
        <th class="center">Categoría</th>
        <th class="center">Tarjeta</th>
        <th class="center">Handicap</th>
        <th class="center">País</th>
        <th class="center">NP</th>
        <th class="center">R</th>
        <th class="center">DQ</th>
        <th class="center">NC</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="player in players | filterBy filterKey | orderBy 'player.surname'">
        <td class="center">{{ $index + 1}}</td>
        <td>
          {{player.player.surname}} {{player.player.mothers_surname}} {{ player.player.name}} {{player.player.middle_name}}
        </td>
        <td class="center"><span class="label label-danger">{{ player.category.code}}</span></td>
        <td class="center">
          <a @click="selectPlayer(player)" title="Ingresar Tarjeta">
            <span class="glyphicon" :class="[icon_card]"></span>
          </a>
        </td>
        <td class="center">{{ player.handicap }}</td>
        <td class="center">
          <span class="flag-icon flag-icon-{{player.player.country.code | lowercase}}"></span>
        </td>
        <td class="center">
          <input type="checkbox" :true-value="5" :false-value="3" disabled>

        </td>
        <td class="center">
          <input type="checkbox" :true-value="6" :false-value="3" disabled>
        </td>
        <td class="center">
          <input type="checkbox" :true-value="4" :false-value="3" disabled>
        </td>
        <td class="center">
          <input type="checkbox" :true-value="7" :false-value="3" disabled>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as actions from '../vuex/actions'
export default {
  vuex: {
    actions
  },
  props: {
    players: {
      default() {
        return []
      }
    },
    filterKey: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      player: [],
      status: [
        'Inscrito',
        'Anulada',
        'Rechazada',
        'Activo',
        'DQ',
        'NP',
        'R',
        'NC'
      ]
    }
  },
  computed: {
    icon_card() {
      if (this.listType === 'ready') {
        return 'glyphicon-search'
      } else {
        return 'glyphicon-pencil'
      }
    }
  },
  methods: {
    selectPlayer(player) {
      this.player = player
      if (this.listType == 'waiting') {
        this.setPlayer(player)
        this.setCardSaved(false)
        this.showPlayer(true)
        this.showCard(true)
        this.initHoles()
      }

      if (this.listType == 'ready') {
        this.setPlayerCards(player)
        this.setPlayer(player)
        this.showPlayer(true)
      }

      this.filterKey = ''
    },
    setStatus (player, status) {
      let confirmation = confirm('Cambiar el estado a ' + this.status[status])
      if (confirmation) {
        this.updatePlayer(player, status)
      }
    },
    checked(player, status) {
      let checked = ''
      if (player.status == status) {
        checked = 'checked'
      }
      return checked
    }
  }
}
</script>

<style lang="css">
.center {
  text-align: center;
}
</style>



/** WEBPACK FOOTER **
 ** PlayersTable.vue?3be2c8b6
 **/